import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { FormattedHTMLMessage } from 'react-intl';
import './styles.css';
import exportResults from '../../ExportResults';

const BusinessPlanExportLink = ({
	icon,
	label,
	activeColorClass,
	disabledOpacity,
	done,
	download,
	businessPlan
}) => (
	<div
		onClick={() => exportResults(businessPlan)}
		style={{ cursor: 'pointer' }}
		className={`business-plan-link ${activeColorClass} ${
			disabledOpacity ? 'business-plan-link-disabled-opacity' : ''
		}`}
	>
		<Icon className="icon business-plan-link-icon-disabled" icon={icon} />
		<Icon
			className="icon business-plan-link-icon-active"
			icon={`${icon}Active`}
		/>
		<FormattedHTMLMessage id={label} />
		{done && <Icon icon={'businessplancheck'} />}
		{download && <Icon icon={'businessplandownload'} />}
	</div>
);

BusinessPlanExportLink.propTypes = {
	icon: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	active: PropTypes.bool,
	disabledOpacity: PropTypes.bool,
	activeColorClass: PropTypes.string,
	done: PropTypes.bool,
	download: PropTypes.bool
};

export default BusinessPlanExportLink;
